export default "__VITE_ASSET__eac9d54a__"